import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Payments from "@/pages/Payments";
import ScheduledPayments from "@/pages/ScheduledPayments";
import PaymentSlip from "@/pages/PaymentSlip";
import Reschedule from "@/pages/Reschedule";
import RescheduleHistory from "@/pages/RescheduleHistory";
import Approvals from "@/pages/Approvals";
import Returns from "@/pages/Returns";
import Suppliers from "@/pages/Suppliers";
import SupplierDetail from "@/pages/SupplierDetail";
import Fabrics from "@/pages/Fabrics";
import Reports from "@/pages/Reports";
import Ledger from "@/pages/Ledger";
import UsersPage from "@/pages/Users";

function Protected({ children, owner }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (owner && !["owner", "accounting"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Routed() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/faktur" element={<Protected><Invoices /></Protected>} />
      <Route path="/faktur/:id" element={<Protected><InvoiceDetail /></Protected>} />
      <Route path="/pembayaran" element={<Protected><Payments /></Protected>} />
      <Route path="/pembayaran-terjadwal" element={<Protected><ScheduledPayments /></Protected>} />
      <Route path="/slip/:id" element={<Protected><PaymentSlip /></Protected>} />
      <Route path="/reschedule" element={<Protected><Reschedule /></Protected>} />
      <Route path="/riwayat-reschedule" element={<Protected><RescheduleHistory /></Protected>} />
      <Route path="/persetujuan" element={<Protected owner><Approvals /></Protected>} />
      <Route path="/retur" element={<Protected><Returns /></Protected>} />
      <Route path="/suppliers" element={<Protected><Suppliers /></Protected>} />
      <Route path="/suppliers/:id" element={<Protected><SupplierDetail /></Protected>} />
      <Route path="/kain" element={<Protected><Fabrics /></Protected>} />
      <Route path="/buku-besar" element={<Protected><Ledger /></Protected>} />
      <Route path="/laporan" element={<Protected><Reports /></Protected>} />
      <Route path="/pengguna" element={<Protected owner><UsersPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routed />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}
